import React, { useCallback, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes";
import { RecoilRoot } from "recoil";

import { Toaster } from "react-hot-toast";
import { NuqsAdapter } from "nuqs/adapters/react";
import ErrorBoundary from "./views/Errors/ErrorBoundary";
import MaintenancePage from "./views/Errors/MaintenancePage";
import Loader from "./views/Loader";

function MaintenanceWrapper({ children }) {
    const [checking, setChecking] = useState(true);
    const [maintenanceStatus, setMaintenanceStatus] = useState(null);

    const checkMaintenance = useCallback(async () => {
        try {
            const tokenMatch = document.cookie.match(/(?:^|;\s*)access_token=([^;]+)/);
            const token = tokenMatch ? decodeURIComponent(tokenMatch[1]) : null;

            const headers = { Accept: "application/json" };
            if (token) {
                headers["Authorization"] = `Bearer ${token}`;
            }

            const response = await fetch(
                (process.env.MIX_API_URL || "") + "/api/v1/maintenance/status",
                { headers }
            );
            const data = await response.json();
            setMaintenanceStatus(data.data ?? null);
        } catch {
            // If the check fails, assume no maintenance
            setMaintenanceStatus(null);
        } finally {
            setChecking(false);
        }
    }, []);

    useEffect(() => {
        checkMaintenance();
    }, [checkMaintenance]);

    if (checking) return <Loader />;

    const isLoginLocalPath = window.location.pathname === "/auth/login/local";
    const isBasePath = window.location.pathname === "/";

    if (maintenanceStatus?.is_active && !maintenanceStatus?.can_bypass && !isLoginLocalPath) {
        if (!isBasePath) {
            window.location.replace("/");
            return <Loader />;
        }

        return (
            <MaintenancePage
                status={maintenanceStatus}
                onRetry={checkMaintenance}
            />
        );
    }

    return children;
}

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <ErrorBoundary>
            <RecoilRoot>
                <Toaster />
                <MaintenanceWrapper>
                    <BrowserRouter>
                        <NuqsAdapter>
                            <AppRoutes />
                        </NuqsAdapter>
                    </BrowserRouter>
                </MaintenanceWrapper>
            </RecoilRoot>
        </ErrorBoundary>
    </React.StrictMode>
);
